// import ServiceHeader from "../../ServiceComponents/ServiceHeader"
import { FaGreaterThan } from "react-icons/fa6";
import ServiceHeader from "../../ServiceComponents/ServiceHeader";
export default function SeperateImageSection() {
    return (
        <>
            <ServiceHeader
                childClass="doctorPage"
                breadcrumb={<>OPD <FaGreaterThan size={15} /> Profile</>}
                title="Profile"
            />
        </>
    )
}